import {  fetchWithAuthToken, postWithAuthToken } from '../axios';
import { showError, showSuccess } from '../js/ui-helpers';
const isObject = value => value instanceof Object && !Array.isArray(value) && !(value instanceof Date);

export default {
    data() {
        return {
            nextRoute: {name: 'home'},
            backRoute: {name: 'home'},
        };
    },
    computed: {
        notificationTitle()
        {
            return '';
        },
        successMessage()
        {
            return ''; 
        },
        errorMessage()
        {
            return "";
        },
        url()
        {
            return '';
        }
    },
    created()
    {
        console.assert(this.form, `Form must be defined & of type object in ${this.$options.name}`);
        console.assert(this.url, `url must be defined as a computed property in ${this.$options.name}`);
        console.assert(this.notificationTitle, `notificationTitle must be defined as a computed property in ${this.$options.name}`);
        console.assert(this.successMessage, `successMessage must be defined as a computed property in ${this.$options.name}`);
        console.assert(this.errorMessage, `errorMessage must be defined as a computed property in ${this.$options.name}`);
        this.fetchInitialData();
    },
    methods: {
        getPlanId()
        {
            return this.$route.params.id;
        },
        updateObjectProps(dest, src)
        {
            console.assert(dest instanceof Object, `Dest is not an object, ${dest}`);
            console.assert(src instanceof Object, `Source is not an object, ${dest}`);
            Object.entries(src).forEach(([key,value]) =>
            {
                if (isObject(value))
                {
                    dest[key] = dest[key]==null ? {} : dest[key];
                    this.updateObjectProps(dest[key], value)
                }
                else
                {
                    dest[key] = value;
                }
            });
        },
        fetchInitialData()
        {
            console.assert(this.url, "Url not defined in computed property");
            fetchWithAuthToken(this.url, {} , {raise404: true})
            .then(res => {
                this.updateObjectProps(this.form, res.data);
            });
        },
        getDefaultErrors(form, errors={}, level=1)
        {
            console.assert(form instanceof Object);
            console.assert(errors instanceof Object);
            if (level===1)
            {
                errors.non_field_errors = [];
            }
            Object.entries(form).forEach(([key,value]) =>
            {
                errors[key] = isObject(value) ? this.getDefaultErrors(value, {}, level+1) : [];
            });
            return errors;
        },
        resetErrors()
        {
            this.updateObjectProps(this.errors, this.getDefaultErrors(this.form));        
        },
        updateErrors(errors)
        {
            this.updateObjectProps(this.errors, errors)
        },
        async save(formElement, {goToNextStep=false}={})
        {
            this.resetErrors();
            if (!formElement.checkValidity())
            {
                formElement.reportValidity();
                return;
            }
            try
            {
                const results = await postWithAuthToken(this.url, this.form, {method: 'put'}, {raise404: true})
                if (results)
                {
                    if (goToNextStep)
                    {
                        this.$router.push(this.nextRoute);
                    }
                    showSuccess(this.notificationTitle, this.successMessage);
                    this.form = results.data;
                }
            }
            catch (error)
            {
                console.log(error.response.data);
                showError(this.notificationTitle, this.errorMessage)
                const errors = error.response && error.response.data;
                if (errors)
                {
                    this.updateErrors(errors);
                }
                else
                {
                    console.error(error, error.response, errors);
                }
            }
        },
        saveAndContinue(formElement)
        {
            this.save(formElement, {goToNextStep: true});
        },
    },
};
